import React from "react";
import { ReactComponent as Plus } from "../assets/components-icons/plus.svg";
import { ReactComponent as Minus } from "../assets/components-icons/minus.svg";
import { CartContext } from "../context/cart";
import { DishesContext } from "../context/dishes";
import { useParams, useHistory, Link } from "react-router-dom";
import CartServerSideStrapi from "../strapi/handle_cart_functions/server_side";
import { UserContext } from "../context/user";
import { ExtraContext } from "../context/ExtraFunctions";
import { CartServerSide } from "../context/api_response";
import { ReactComponent as RightArrow } from "../assets/components-icons/right-arrow.svg";
import { size_list } from "../helpers/size_list";
import { crust_list } from "../helpers/crust_list";
import PizzaGif from "../strapi/loading-gifs/Pizza-loading";
import { Button } from "../components/Layout/Elements";
import { SinglePageWrapper } from "../components/Layout/SinglePageWrapper";
import ImageCarousel from '../components/Img_carousel';
import { motion } from "framer-motion";


export default function SingleProduct() {
  const { handleAlert, setGif, edit } = React.useContext(ExtraContext);
  const { userInfo } = React.useContext(CartServerSide);
  const { dishes } = React.useContext(DishesContext);

  const {
    add_to_cart,
    get_crust,
    get_size,
    size,
    amount,
    handleIncrease,
    handleDecrease,
    crust,
  } = React.useContext(CartContext);

  const { user } = React.useContext(UserContext);
  let isEmpty = !crust || !amount || !size;
  const { id, title, category } = useParams();
  let history = useHistory();
  let dish = dishes.find((item) => item.id === parseInt(id));

  const [indexImg, setIndexImg] = React.useState(0)
  const handleIndexImg = (id) => {
     setIndexImg(id)
   }

  if (!dish) {
    return <PizzaGif />;
  } else {
    let {
      Title,
      Description,
      price_small,
      price_medium,
      price_large,
      image,
    } = dish;

    return (
      <SinglePageWrapper>
        <div className="current-location mt-5">
          <Link to="/">Home</Link>
          <RightArrow className="svgAll" />
          <Link to="/">{category}</Link>
          <RightArrow className="svgAll" />
          <Link to={`/pizza-product/${title}/${category}/${id}`}>{title}</Link>
        </div>


        <div className="borderAll borderGrey"></div>

              <section className='single-page-grid'>
              <div className="grid-first">
                <motion.img 
                key={image[indexImg].url}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1.5, x: 0 }}
                transition={{ duration: 1 }}
                exit={{ opacity: 0 }}
                src={image[indexImg].url} alt={Title} />
                <ImageCarousel  indexImg={indexImg}  images={image} handleIndexImg={handleIndexImg} />
              </div>
              <div className="grid-second">
                <div className="product-descr">
                  <div>
                    <h4>{Title}</h4>
                  </div>

                  <div>
                    <p>{Description}</p>
                  </div>

                  <div className="borderAll borderGrey"></div>

                  <div className="section-pick">
                    <div>
                      <div className="mb-2">
                        <span className="pick-price">Select Crust</span>
                      </div>

                      {crust_list.map((item) => {
                        return (
                          <div key={item.id} className="mt-1">
                            <label className="container-radio form-check-label">
                              <input
                                onClick={get_crust}
                                value={item.value}
                                name={item.name}
                                type="radio"
                              />
                              <span className="checkmark"></span>
                              <span className="pick-size">
                                {item.text}
                              </span>
                              <small>{item.extra}</small>
                            </label>
                          </div>
                        );
                      })}
                    </div>

                    <div className="d-block">
                      <div className="mb-2">
                        <span className="pick-price">Select Size</span>
                      </div>

                      {size_list.map((item) => {
                        return (
                          <label key={item.id} className="container-radio">
                            <input
                              onClick={get_size}
                              value={item.value}
                              name={item.name}
                              type="radio"
                            />
                            <span className="checkmark"></span>
                            <span className="pick-size">{item.text}</span>
                            <small className="pick-price ml-1">
                              €{item.text === "SM" && price_small}
                              {item.text === "MD" && price_medium}
                              {item.text === "LG" && price_large}
                            </small>
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  { !isEmpty ? <div className='footer-section'>
                    <div className='quantity-div'>
                      <span>Quantity</span>
                    </div>
                      <div className='inside-footer'>
                        <div className='amount-handler border-around'>
                          <div><Plus onClick={handleIncrease} /></div>
                          <div>{amount}</div>
                          <div><Minus onClick={handleDecrease} /></div>
                        </div>
                        <Button
                            bg="var(--addtoCart)"
                            padding="13px"
                            fontWeight="bold"
                            fontSize="16px"
                            radius="40px"
                            width="100%"
                            maxWidth='300px'
                            onClick={(e) => {
                              CartServerSideStrapi(
                                e,
                                user,
                                userInfo,
                                dish,
                                handleAlert,
                                history,
                                setGif,
                                edit,
                                add_to_cart
                              );
                            }}
                            type="submit"
                            className="add-to-cart-btn"
                          >
                            <span> { edit ? "Update Cart" : "Add to cart"}</span>
                          </Button>
                      </div>
                    </div> : <h5> Please fill the forms to continue </h5> }

                  {/* {!isEmpty ? (

                    <div className="d-block ml-4 mt-4">
                      <div className="mb-2">
                        <span>Quantity</span>
                      </div>

                      <div className="d-md-flex justify-content-around  align-items-center  mt-3">
                        <div
                          className="d-flex border-around  align-items-center col-lg-6 col-12 mt-1 col-md-6 
                          justify-content-around"
                        >
                          <div>
                            <Plus onClick={handleIncrease} className="svgAll" />
                          </div>

                          <div>
                            <span>{amount}</span>
                          </div>

                          <div>
                            <Minus
                              onClick={handleDecrease}
                              className="svgAll"
                            />
                          </div>
                        </div>

                        <div className="col-lg-8  col-12 mt-1 col-md-6">
                          <Button
                            bg="var(--addtoCart)"
                            padding="13px"
                            fontWeight="bold"
                            fontSize="16px"
                            radius="40px"
                            width="100%"
                            maxWidth='300px'
                            onClick={(e) => {
                              CartServerSideStrapi(
                                e,
                                user,
                                userInfo,
                                dish,
                                handleAlert,
                                history,
                                setGif,
                                edit,
                                add_to_cart
                              );
                            }}
                            type="submit"
                            className="add-to-cart-btn"
                          >
                            <span> { edit ? "Update Cart" : "Add to cart"}</span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <h5 className="text-center mt-3">
                      Please fill all the forms to continue
                    </h5>
                  )} */}
                </div>
              </div>
</section>
      </SinglePageWrapper>
    );
  }
}
